import script from "./KaiyuanDataList.vue?vue&type=script&setup=true&lang=js"
export * from "./KaiyuanDataList.vue?vue&type=script&setup=true&lang=js"

import "./KaiyuanDataList.vue?vue&type=style&index=0&id=7c5c4da9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5c4da9"]])

export default __exports__